import { useLang } from '@common/context/language-provider';
import { useSurveyContext } from '@common/context/survey-context';
import { useUserContext } from '@common/context/user';
import { postApiV1OauthLogout } from '@konova/api';
import { useToast } from '@konova/ui/use-toast';
import { SpaceAdminRoutes } from '@routes/space-admin-routes';
import { SpaceRoutes } from '@routes/space-routes';
import { SurveyRoutes } from '@routes/survey-routes';
import { useTranslation } from 'react-i18next';
import { generatePath, useMatch } from 'react-router';

export type UseLogOutOpts = {
  silent?: boolean;
};

/**
 * Custom hook to handle user logout functionality.
 */
export const useLogOut = (opts?: UseLogOutOpts) => {
  const [t] = useTranslation();
  const toast = useToast();
  const userContext = useUserContext();
  const { survey } = useSurveyContext();
  const isSpaceAdminRoute = useMatch('/:lang/admin/*');
  const isSurveysRoute = useMatch('/:lang/surveys/*');
  const isSurveyRoute = useMatch('/:lang/:surveySlug/*');
  const { language: lang } = useLang();

  const logOut = async (silent?: boolean, redirect?: boolean) => {
    if (opts?.silent !== true && silent !== true) {
      toast.add(t<string>('components.main.logout-successful'), 'success');
    }

    if (survey) {
      const feedbackGroupsColumns = localStorage.getItem(
        `surveyDocumentFeedbackEvaluationGroupQueryForSurvey${survey?.id}`
      );
      userContext.setUser(null);
      localStorage.clear();
      if (feedbackGroupsColumns)
        localStorage.setItem(
          `surveyDocumentFeedbackEvaluationGroupQueryForSurvey${survey?.id}`,
          feedbackGroupsColumns
        );
    }

    await postApiV1OauthLogout();
    if (redirect === false) {
      return Promise.resolve();
    }

    if (isSpaceAdminRoute) {
      window.location.href = generatePath(SpaceAdminRoutes.login, { lang });
    } else if (isSurveyRoute && !isSurveysRoute) {
      window.location.href = generatePath(SurveyRoutes.Index, { lang, surveySlug: isSurveyRoute.params.surveySlug! });
    } else {
      window.location.href = generatePath(SpaceRoutes.index, { lang });
    }
    return Promise.resolve();
  };

  return logOut;

};